import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0651 = React.lazy(() => import('./symbols/0651_star_favorite_rating'));
const Symbol0652 = React.lazy(() => import('./symbols/0652_star_favorite_rating'));
const Symbol0653 = React.lazy(() => import('./symbols/0653_like_heart_favorite_rating_love'));
const Symbol0654 = React.lazy(() => import('./symbols/0654_unlike_heart_broken_break_love'));
const Symbol0655 = React.lazy(() => import('./symbols/0655_like_heart_favorite_rating_love'));
const Symbol0656 = React.lazy(() => import('./symbols/0656_medal_award_rating_prize_achievement'));
const Symbol0657 = React.lazy(() => import('./symbols/0657_medal_award_rating_prize_achievement'));
const Symbol0658 = React.lazy(
  () => import('./symbols/0658_cup_place_winner_award_prize_achievement')
);
const Symbol0659 = React.lazy(
  () => import('./symbols/0659_medal_first_place_winner_award_prize_achievement')
);
const Symbol0660 = React.lazy(() => import('./symbols/0660_shape_new_discount'));
const Symbol0661 = React.lazy(() => import('./symbols/0661_like_thumb_up_vote'));
const Symbol0662 = React.lazy(() => import('./symbols/0662_dislike_thumb_down_vote'));
const Symbol0663 = React.lazy(() => import('./symbols/0663_like_thumb_up_vote'));
const Symbol0664 = React.lazy(() => import('./symbols/0664_dislike_thumb_down_vote'));
const Symbol0665 = React.lazy(() => import('./symbols/0665_vote_ticket_paper_voting'));
const Symbol0666 = React.lazy(() => import('./symbols/0666_award_achievement_prize_medal'));
const Symbol0667 = React.lazy(() => import('./symbols/0667_star_rating_favorite_point'));
const Symbol0668 = React.lazy(() => import('./symbols/0668_up_vote_plus_higher'));
const Symbol0669 = React.lazy(() => import('./symbols/0669_down_vote_minus_lower'));
const Symbol0670 = React.lazy(() => import('./symbols/0670_diamond_prize_award_jewellery_ring'));

export interface IProps {}

const Voting: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0651_star_favorite_rating" symbol={<Symbol0651 />} />
      <LazySymbol id="0652_star_favorite_rating" symbol={<Symbol0652 />} />
      <LazySymbol id="0653_like_heart_favorite_rating_love" symbol={<Symbol0653 />} />
      <LazySymbol id="0654_unlike_heart_broken_break_love" symbol={<Symbol0654 />} />
      <LazySymbol id="0655_like_heart_favorite_rating_love" symbol={<Symbol0655 />} />
      <LazySymbol id="0656_medal_award_rating_prize_achievement" symbol={<Symbol0656 />} />
      <LazySymbol id="0657_medal_award_rating_prize_achievement" symbol={<Symbol0657 />} />
      <LazySymbol id="0658_cup_place_winner_award_prize_achievement" symbol={<Symbol0658 />} />
      <LazySymbol
        id="0659_medal_first_place_winner_award_prize_achievement"
        symbol={<Symbol0659 />}
      />
      <LazySymbol id="0660_shape_new_discount" symbol={<Symbol0660 />} />
      <LazySymbol id="0661_like_thumb_up_vote" symbol={<Symbol0661 />} />
      <LazySymbol id="0662_dislike_thumb_down_vote" symbol={<Symbol0662 />} />
      <LazySymbol id="0663_like_thumb_up_vote" symbol={<Symbol0663 />} />
      <LazySymbol id="0664_dislike_thumb_down_vote" symbol={<Symbol0664 />} />
      <LazySymbol id="0665_vote_ticket_paper_voting" symbol={<Symbol0665 />} />
      <LazySymbol id="0666_award_achievement_prize_medal" symbol={<Symbol0666 />} />
      <LazySymbol id="0667_star_rating_favorite_point" symbol={<Symbol0667 />} />
      <LazySymbol id="0668_up_vote_plus_higher" symbol={<Symbol0668 />} />
      <LazySymbol id="0669_down_vote_minus_lower" symbol={<Symbol0669 />} />
      <LazySymbol id="0670_diamond_prize_award_jewellery_ring" symbol={<Symbol0670 />} />
    </>
  );
});

Voting.displayName = 'Voting';

export default Voting;
